function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMinus = function SvgMinus(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 3025.1217 3023.6212",
    ref: svgRef
  }, props), React.createElement("g", {
    transform: "translate(-3874.3782,-5359.5421)",
    style: {
      stroke: "none"
    }
  }, React.createElement("path", {
    style: {
      fill: "currentColor",
      stroke: "none",
      strokeWidth: 25
    },
    d: "m 5031,6797 h 712 c 41,0 75,33 75,75 v 0 c 0,41 -34,75 -75,75 h -712 c -41,0 -75,-34 -75,-75 v 0 c 0,-42 34,-75 75,-75 z m 1083,-585 c 0,48 -58,130 -142,44 -24,-24 -35,-32 -61,-53 -258,-213 -657,-239 -945,-70 -14,9 -22,11 -34,19 -79,48 -184,147 -237,225 l -77,128 c -108,226 -108,498 -2,728 126,272 429,488 733,488 249,0 454,-64 634,-245 69,-68 125,-143 169,-233 109,-221 110,-471 19,-701 -17,-41 -59,-98 -16,-145 20,-23 82,-34 116,14 67,93 116,345 116,476 0,82 -19,192 -42,261 -20,62 -41,122 -71,179 -6,13 -13,26 -21,40 l -155,201 c -80,88 -191,165 -302,213 -467,204 -942,48 -1229,-340 l -68,-114 c -9,-15 -15,-32 -22,-46 -168,-346 -90,-761 143,-1047 20,-25 40,-46 62,-67 20,-21 39,-39 63,-59 72,-61 142,-107 232,-146 293,-128 552,-115 841,9 68,29 296,177 296,241 z"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMinus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/minus.df42845b.svg";
export { ForwardRef as ReactComponent };